function getMessageFromErrorBody(body: unknown): string | null {
  if (body == null) return null
  if (typeof body === "string") return body
  if (Array.isArray(body)) return getMessageFromErrorBody(body[0])
  if (typeof body !== "object") return null
  if ("errors" in body && Array.isArray(body.errors)) return getMessageFromErrorBody(body.errors[0])
  if ("error" in body && body.error != null) return getMessageFromErrorBody(body.error)
  if ("message" in body && typeof body.message === "string") return body.message
  return null
}

type QueryResultLike = { status?: string, error?: unknown } | null | undefined

function isSuppressedMessage(message: string): boolean {
  return message.trim().toLowerCase().startsWith("internal error")
}

export function extractFirstGraphqlErrorMessage(results: unknown): string | null {
  if (!Array.isArray(results)) return null
  for (const result of results as QueryResultLike[]) {
    if (!result || result.status !== "error") continue
    const message = getMessageFromErrorBody(result.error)
    if (message && !isSuppressedMessage(message)) return message
  }
  return null
}

export interface GraphqlError { message?: string }

export class GraphqlApiError extends Error {
  errors: GraphqlError[]

  constructor(errors: GraphqlError[] | null | undefined) {
    const list = Array.isArray(errors) ? errors : []
    super(list[0]?.message ?? "GraphQL API error")
    Object.setPrototypeOf(this, GraphqlApiError.prototype)
    this.name = "GraphqlApiError"
    this.errors = list
  }
}

interface ResultWithApiMessages { apiMessages?: { errors?: GraphqlError[] } }

export function rejectOnGraphqlErrors<TResult extends ResultWithApiMessages>(
  resolve: (value: TResult) => void,
  reject: (reason: unknown) => void,
) {
  return (result: TResult) => {
    const apiErrors = result?.apiMessages?.errors
    if (Array.isArray(apiErrors) && apiErrors.length > 0) {
      reject(new GraphqlApiError(apiErrors))
    } else {
      resolve(result)
    }
  }
}
